import { Component } from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, Platform, ViewController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";

@Component({
  selector: 'page-archive-date-wise-report',
  templateUrl: 'archive-date-wise-report.html',
})
export class ArchiveDateWiseReportPage {

  MonthReport: any;

  constructor(public navCtrl: NavController,
              public service: ServiceProvider,
              public viewCtrl: ViewController,
              public loadingCtrl: LoadingController,
              public platform : Platform,
              public navParams: NavParams) {

    this.platform.ready().then(() => {

      this.loadvalues();
    });


  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ArchiveDateWiseReportPage');
  }

  loadvalues() {

    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    loading.present();

    this.MonthReport = [];

    this.service.httpcall('app_web_service/get_archive_progress_monthwise_report?').subscribe(data => {

      if(data){
        this.MonthReport = data;
        console.log('MonthReport',this.MonthReport);
        loading.dismiss();
      }else{
        loading.dismiss();
      }

    })
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.loadvalues();

    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  backBTN() {
    this.viewCtrl.dismiss();
  }


}



// WEBPACK FOOTER //
// ./src/pages/archive-date-wise-report/archive-date-wise-report.ts